import { createSlice } from '@reduxjs/toolkit'
import { fetchSuggestData } from 'features/anonymousAuth/services/fetchSuggestData'
import { reviewSuggestion } from 'features/anonymousAuth/services/reviewSuggestion'

const initialState = {
    suggests: [],
    suggest: [],
    arraySuggests: [],
    status: null,
    error: null,
    direction: [0, 0],
    currentSuggestId: null,
    currentText: '',
    currentImage: '',
    currentCollection: [],
    currentSpeak: '',
    currentId: null,
    currentAuthor: null,
}

const advance = (state, direction) => {
    state.arraySuggests.shift()
    state.arraySuggests.push(...state.suggests.splice(0, 1))
    state.suggest = state.arraySuggests[0] ? [state.arraySuggests[0]] : []
    const next = state.arraySuggests[0]
    state.currentText = next?.text || ''
    state.currentImage = next?.img || ''
    state.currentId = next?.userId ?? null
    state.currentAuthor = next?.author || null
    state.currentSuggestId = next?.id ?? null
    state.direction = direction
    state.currentCollection = []
    state.currentSpeak = ''
}

const adminSlice = createSlice({
    name: 'admin',
    initialState,
    reducers: {
        changeCurrentText(state, action) {
            state.currentText = action.payload
        },
        changeCurrentImg(state, action) {
            state.currentImage = action.payload
        },
        changeCurrentCollection(state, action) {
            if (state.currentCollection.includes(action.payload)) {
                state.currentCollection = state.currentCollection.filter(
                    (item) => action.payload !== item
                )
            } else {
                state.currentCollection.push(action.payload)
            }
        },
        changeCurrentSpeak(state, action) {
            state.currentSpeak = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchSuggestData.pending, (state) => {
                state.status = 'loading'
                state.error = null
            })
            .addCase(fetchSuggestData.fulfilled, (state, action) => {
                state.suggests = action.payload.filter(
                    (item) =>
                        !item.checked &&
                        item.userId !== null &&
                        item.userId !== undefined
                )
                state.arraySuggests = state.suggests.splice(0, 3)
                const first = state.arraySuggests[0]
                state.suggest = first ? [first] : []
                state.currentText = first?.text || ''
                state.currentImage = first?.img || ''
                state.currentId = first?.userId ?? null
                state.currentAuthor = first?.author || null
                state.currentSuggestId = first?.id ?? null
                state.status = 'resolved'
            })
            .addCase(fetchSuggestData.rejected, (state, action) => {
                state.status = 'error'
                state.error = action.error.message
            })
            .addCase(reviewSuggestion.pending, (state) => {
                state.status = 'saving'
                state.error = null
            })
            .addCase(reviewSuggestion.fulfilled, (state, action) => {
                advance(state, action.payload.direction)
                state.status = 'resolved'
            })
            .addCase(reviewSuggestion.rejected, (state, action) => {
                state.status = 'error'
                state.error = action.error.message
            })
    },
})

export default adminSlice.reducer
export const { actions: adminActions } = adminSlice
